/**
 * Persistência de sessão do Console Administrativo PETBEA.
 *
 * "Manter conectado" ligado  => sessão persistente (padrão do Supabase).
 * "Manter conectado" desligado => sessão temporária: encerra quando o navegador é fechado.
 *
 * O marcador temporário vive no sessionStorage (some ao fechar a aba/navegador) e é
 * espelhado no localStorage apenas como sinal de "havia sessão temporária ativa".
 * Um canal entre abas evita derrubar a sessão quando outra aba ainda está aberta.
 */
const CHAVE_TEMP = 'petbea_console_sessao_temporaria';
export const CANAL_SESSAO = 'petbea_console_sessao_canal';

/** Aplica a preferência escolhida no login. */
export function aplicarPreferenciaSessao(manterConectado: boolean): void {
  try {
    if (manterConectado) {
      localStorage.removeItem(CHAVE_TEMP);
      sessionStorage.removeItem(CHAVE_TEMP);
      return;
    }
    localStorage.setItem(CHAVE_TEMP, '1');
    sessionStorage.setItem(CHAVE_TEMP, '1');
  } catch {
    /* storage indisponível — segue com o padrão persistente do Supabase */
  }
}

/** Remove os marcadores (usado no logout e ao expirar a sessão temporária). */
export function limparPreferenciaSessao(): void {
  try {
    localStorage.removeItem(CHAVE_TEMP);
    sessionStorage.removeItem(CHAVE_TEMP);
  } catch {
    /* ignore */
  }
}

/**
 * Decide se uma sessão temporária deve ser encerrada (navegador reaberto).
 * Consulta outras abas pelo canal antes de decidir, para nunca derrubar
 * uma sessão que ainda esteja viva em outra aba.
 */
export async function decidirEncerrarSessaoTemporaria(): Promise<boolean> {
  let candidata = false;
  try {
    candidata = localStorage.getItem(CHAVE_TEMP) === '1' && sessionStorage.getItem(CHAVE_TEMP) !== '1';
  } catch {
    return false;
  }
  if (!candidata) return false;

  const outraAbaViva = await verificarOutraAba();
  if (outraAbaViva) {
    // Outra aba mantém a sessão viva: adota o marcador nesta aba também.
    try {
      sessionStorage.setItem(CHAVE_TEMP, '1');
    } catch {
      /* ignore */
    }
    return false;
  }

  limparPreferenciaSessao();
  return true;
}

function verificarOutraAba(): Promise<boolean> {
  return new Promise((resolve) => {
    if (typeof BroadcastChannel === 'undefined') {
      resolve(false);
      return;
    }
    const canal = new BroadcastChannel(CANAL_SESSAO);
    let respondido = false;
    const finalizar = (vivo: boolean) => {
      if (respondido) return;
      respondido = true;
      canal.close();
      resolve(vivo);
    };
    canal.onmessage = (evento) => {
      if (evento.data === 'petbea-pong') finalizar(true);
    };
    canal.postMessage('petbea-ping');
    window.setTimeout(() => finalizar(false), 220);
  });
}